export interface TimeEntry {
  id: string;
  /**
   * Parent client account id (tenant).
   * Prefer this over organizationId going forward.
   */
  clientId: string;
  /**
   * @deprecated Legacy tenant field — mirrored from clientId for older queries/rules.
   */
  organizationId?: string;
  /** Project document id when entry is tied to a project; omit for client-level. */
  projectId?: string;
  contractId?: string;
  /** Optional linked task id under the selected project. */
  taskId?: string;
  /** Optional task title snapshot for list display. */
  taskTitle?: string;
  type?: string;       // work type: Development, Meeting, Research, etc.
  userId: string;
  serviceId?: string;
  description: string;
  startTime: Date;
  endTime: Date;
  duration: number; // in minutes
  billable: boolean;
  status: TimeEntryStatus;
  createdAt: Date;
  updatedAt: Date;
}

export const TIME_ENTRY_TYPES = [
  'Development',
  'Meeting',
  'Research',
  'Planning',
  'Office Visit',
  'Consultation',
  'Documentation',
  'Strategy',
] as const;

export enum TimeEntryStatus {
  PENDING = 'pending',
  REJECTED = 'rejected',
  BILLED = 'billed'
}

/** Resolve parent client id from a time entry (new or legacy shape). */
export function timeEntryClientId(entry: Pick<TimeEntry, 'clientId' | 'organizationId' | 'projectId'>): string {
  // After migration clientId is parent. Legacy docs had organizationId as parent
  // and clientId as project — callers should prefer organizationId when clientId
  // equals projectId, but once migrated organizationId mirrors clientId.
  return entry.clientId || entry.organizationId || '';
}

/** Resolve project id from a time entry (new or legacy shape). */
export function timeEntryProjectId(entry: Pick<TimeEntry, 'clientId' | 'organizationId' | 'projectId'>): string | undefined {
  if (entry.projectId) return entry.projectId;
  // Legacy: project lived on clientId while organizationId held the parent.
  if (entry.clientId && entry.organizationId && entry.clientId !== entry.organizationId) {
    return entry.clientId;
  }
  return undefined;
}
